// Copyright (c) 2016 Deere & Company

import FormValidation from '../state/form-validation';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updatedFormValidity = (state, action) =>
    FormValidation.update(state, {
        [action.property]: {
            $set: action.validity
        }
    });

const resetFormValidation = () => getDefaultState().formValidation;

export default (state = getDefaultState().formValidation, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_NORMAL]: resetFormValidation,
        [actions.RESET_CLAIM_NORMAL_FORM_VALIDATION]: resetFormValidation,
        [actions.UPDATE_CLAIM_NORMAL_FORM_VALIDATION]: updatedFormValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/form-validation.js